import { PaletteOptions } from '@mui/material/styles'


import colors from '@/constants/colors'

declare module '@mui/material/styles/createPalette' {
  interface TypeBackground {
    idle: string
  }
}

const palette: PaletteOptions = {
  common: {
    black: '#000',
    white: '#FFF',
  },
  primary: {
    light: colors['primary-light'],
    main: colors['primary-main'],
    dark: '#00202C',
  },
  secondary: {
    light: '#fef5d2',
    main: '#fef9c3',
    dark: '#b1aa8b',
  },
  error: {
    main: '#dc2626',
  },
  background: {
    paper: '#ffffff',
    default: '#f9fafb',
    idle: '#e5e7eb',
  },
}

export default palette
